"use strict";
'use es6';
/**
 * Creates a throttled version of the passed in function that will
 * only call the original function once per [wait] milliseconds. All subsequent
 * calls will be ignored until the [wait] period is over
 *
 * @param {Function} fn      Function to invoke
 * @param {Number}   wait    Number of milliseconds for wait period
 * @param {Object}   context The [this] context for the function arg
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.throttle = void 0;

var throttle = function throttle(fn, wait, context) {
  var available = true;

  function throttler() {
    var callback = function callback() {
      available = true;
    };

    if (available) {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      fn.apply(context, args);
      available = false;
      setTimeout(callback, wait);
    }
  }

  return throttler;
};

exports.throttle = throttle;